import React from 'react';
import { HandoverPackSectionResponse, PartResponse } from '../documentResponse';
import { HandoverPackSectionContext } from './HandoverPackSectionContext';

type Props = {
  handoverPackSections: Array<HandoverPackSectionResponse>;
  parts: Array<PartResponse>;
  refreshContext: () => void;
  children?: React.ReactNode;
};

export const HandoverPackSectionProvider = ({ handoverPackSections, parts, refreshContext, children }: Props) => (
  <HandoverPackSectionContext.Provider
    value={{
      allDocuments: handoverPackSections.flatMap(section => section.documents),
      handoverPackSections,
      parts,
      refreshContext,
    }}
  >
    {children}
  </HandoverPackSectionContext.Provider>
);
